var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes})
}
var staticRenderFns = []

export { render, staticRenderFns }